import * as Yup from 'yup';

export const propertyPayloadSchema = Yup.object({
  propertyType: Yup.string().nullable().required('validationErrors.isRequired'),
  propertyArea: Yup.string().nullable().required('validationErrors.isRequired'),
  usePurpose: Yup.object().nullable().required('validationErrors.isRequired').shape({
    value: Yup.string().nullable().required('validationErrors.isRequired'),
  }),
});

export const propertyCalculatorSchema = propertyPayloadSchema.shape({
  start: Yup.date()
    .typeError('validationErrors.invalidDate')
    .required('validationErrors.isRequired'),
  end: Yup.date()
    .typeError('validationErrors.invalidDate')
    .required('validationErrors.isRequired'),
});

export const propertyContractCalculatorSchema = propertyCalculatorSchema.shape({
  hasAgreed: Yup.boolean().oneOf([true]),
});
